/* External */
import { useEffect, useState } from 'react';

export function useIsResponsive(query = '(max-width: 659px)') {
  const [isResponsive, setIsResponsive] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = (e) => setIsResponsive(Boolean(e.matches));

    media.addEventListener('change', listener);

    return () => media.removeEventListener('change', listener);
  }, [query]);

  return isResponsive;
}
